module.exports = __webpack_public_path__ + "img/ext6.36104b13.png";